module.exports = __webpack_public_path__ + "img/air_red.b66647db.svg";